import { DateTime } from "luxon";
import { validateDate } from "../../DateFieldSingle/internal/utils";

type DateConstraints = {
  unavailable?: {
    dates?: DateTime[];
    daysOfWeek?: number[];
  };
  minDate?: DateTime;
  maxDate?: DateTime;
};

export function validateDateRange({
  required,
  startDate,
  endDate,
  startDateConstraints,
  endDateConstraints,
}: {
  required?: boolean;
  startDate: DateTime | null;
  endDate: DateTime | null;
  startDateConstraints: DateConstraints;
  endDateConstraints: DateConstraints;
}) {
  if (!required && !startDate && !endDate) return true;
  return (
    validateDate({
      date: startDate,
      constraints: { ...startDateConstraints, required: true },
    }) &&
    validateDate({
      date: endDate,
      constraints: { ...endDateConstraints, required: true },
    }) &&
    (!startDate || !endDate || startDate <= endDate)
  );
}
